export default __webpack_public_path__ + "static/media/640_dummy2016-raumgestalter01-de.f9bc1d69.png";